<template>

    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-content">
            <article class="message">
                <div class="message-body">
                    <ElencoContatti
                        :bottoneAggiungiVisibile=props.bottoneAggiungiVisibile
                        :testoDaCercare=testoDaCercare
                        :visioneCompatta=true
                        @statoInterfacciaCambiato="cambiaStatoInterfaccia"
                        @elementoSelezionato="bSelezionaElemento"/>
                </div>
            </article>
        </div>
    </div>

</template>

<script setup>
    import ElencoContatti from "./ElencoContatti.vue";
    import { defineProps, defineEmits, ref } from "vue";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true }
    });
    const emit = defineEmits(['elementoSelezionato']);

    // VARIABILI DEL COMPONENTE
    const testoDaCercare = ref(null);

    // SETUP DEL COMPONENTE

    // FUNZIONI DEL COMPONENTE
    function bSelezionaElemento(tempElemento) {
        emit('elementoSelezionato', tempElemento);
    }

    function cambiaStatoInterfaccia(tempStato) {
        testoDaCercare.value = tempStato.testoRicercaContatti;
    }
</script>